import { render } from "./preset-event.vue?vue&type=template&id=16704809&lang=pug"
import script from "./preset-event.vue?vue&type=script&lang=js"
export * from "./preset-event.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__